import { FC } from 'react'
import styles from './BestWayToWakeUp.module.scss'
import { BestWayToWakeUpProps } from './types'
import { VideoGif } from 'components/basic/VideoGif'

export const BestWayToWakeUp: FC<BestWayToWakeUpProps> = (props) => {
	const {} = props
	return (
		<div className={styles.container}>
			<div className={styles.inner_container}>
				<div className={styles.video_container}>
					<VideoGif src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/Pod4+Front+View.mp4'} />
				</div>
				<h2>The best way to wake up</h2>
				<p>Each morning, wake up with a gentle vibration and thermal change that rises in intensity gradually over 5 minutes. No more noisy alarms or waking your partner up in the morning.</p>
			</div>
		</div>
	)
}
